export default {
  PERSONALCENTER_CONFIGURATION_AIRROUTE: {
    key: 'personalcenter_configuration_airroute',
    label: '个人中心-配置管理-【航线维护】'
  },
  FAVORITE_AIRROUTE: {
    key: 'favorite_airroute',
    label: '收藏夹-【航线维护】'
  },
  QUICKENTRY_AIRROUTE: {
    key: 'quickentry_airroute',
    label: '快捷入口-【航线维护】'
  },
  MENU_QUERY_AIRROUTE: {
    key: 'menu_query_airroute',
    label: '菜单查询-【航线维护】'
  },
  CONFIGURATION_AIRROUTE_OPENED_CLOSE: {
    key: 'configuration_airroute_opened_close',
    label: '配置管理-航线维护-已开通航线-【关闭航线】'
  },
  CONFIGURATION_AIRROUTE_OPENED_BATCHCLOSE: {
    key: 'configuration_airroute_opened_batchclose',
    label: '配置管理-航线维护-已开通航线-【批量关闭】'
  },
  CONFIGURATION_AIRROUTE_OPENED_ONEPAGE: {
    key: 'configuration_airroute_opened_onepage',
    label: '配置管理-航线维护-已开通航线-【当页全选】'
  },
  CONFIGURATION_AIRROUTE_OPENED_ALLPAGE: {
    key: 'configuration_airroute_opened_allpage',
    label: '配置管理-航线维护-已开通航线-【全部全选】'
  },
  CONFIGURATION_AIRROUTE_OPENED_NUMBERPAGE: {
    key: 'configuration_airroute_opened_numberpage',
    label: '配置管理-航线维护-已开通航线'
  },
  CONFIGURATION_AIRROUTE_CLOSED_OPEN: {
    key: 'configuration_airroute_closed_open',
    label: '配置管理-航线维护-未开通航线-【开通航线】'
  },
  CONFIGURATION_AIRROUTE_CLOSED_BATCHOPEN: {
    key: 'configuration_airroute_closed_batchopen',
    label: '配置管理-航线维护-未开通航线-【批量开通】'
  },
  CONFIGURATION_AIRROUTE_CLOSED_ONEPAGE: {
    key: 'configuration_airroute_closed_onepage',
    label: '配置管理-航线维护-未开通航线-【当页全选】'
  },
  CONFIGURATION_AIRROUTE_CLOSED_ALLPAGE: {
    key: 'configuration_airroute_closed_allpage',
    label: '配置管理-航线维护-未开通航线-【全部全选】'
  },
  CONFIGURATION_AIRROUTE_CLOSED_NUMBERPAGE: {
    key: 'configuration_airroute_closed_numberpage',
    label: '配置管理-航线维护-未开通航线'
  }
}
